// Contrato de erro do backend (ApiError): {detail, code, message, retry_after?, action?, errors?: [{field, message}]}.
// Corpo legado traz só detail string. A tela mostra message; não há tabela de mensagens no front.
export function toApiError(err) {
  const response = err?.response;
  if (!response) {
    return {
      status: null,
      code: null,
      message: 'Não foi possível conectar ao servidor. Tente novamente.',
      retryAfter: null,
      action: null,
      errors: [],
    };
  }

  const data = response.data || {};
  return {
    status: response.status,
    code: data.code || null,
    message: data.message || (typeof data.detail === 'string' && data.detail) || 'Erro inesperado. Tente novamente.',
    retryAfter: data.retry_after ?? null,
    action: data.action || null,
    errors: Array.isArray(data.errors) ? data.errors : [],
  };
}
